import React from "react";
import "./Careers.css";
import HeroSVG from "./IMG/CareersHero.svg";
import JobPostingImage from "./IMG/job.jpeg";
import JobPostingImage1 from "./IMG/job1.jpeg";
import JobPostingImage2 from "./IMG/shared image.jpg";
import JobPostingImage3 from "./IMG/3 job.jpg";
import JobPostingImage4 from "./IMG/4 job.jpg";
import JobPostingImage5 from "./IMG/5 job.jpg";
import JobPostingImage6 from "./IMG/new 6.jpeg";
import NavBar from "../Navigation/NavBar";
import Footer from "../Footer/Footer";
import WhatsAppWidgetComponent from "../Whatsapp/WhatsAppWidgetComponent";
import { Helmet } from "react-helmet-async";

function Careers() {
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="careers-page">
      <Helmet>
        <title>Careers — Quarec Resources</title>
      </Helmet>
      <NavBar />
      <section className="careers-hero">
        <div className="hero-content"><br />
          <h1>Join Our Team</h1>
          <p className="subtitle">Explore career opportunities and confirm current openings with our recruitment team</p>
        </div>
      </section>

      <section className="featured-job-section">
      <div className="featured-job-container">
          <div className="featured-job-image-wrapper">
            <img src={JobPostingImage6} alt="Current Job Openings" className="featured-job-img" />
            <div className="image-overlay-glow"></div>
          </div>
          <div className="featured-job-details">
            <div className="accent-pill">Confirm availability</div>
            <h2>SALES CUM EXHIBITION COORDINATOR</h2>
            <p>
              We're looking for passionate individuals to join our growing team. 
              Review our current openings and take the next step in your professional journey with Quarec Resources.
            </p>
            <div className="cta-group">
              <a href="mailto:career4@quarec.com" className="apply-cta primary">Share Your CV</a>
              <a href="tel:9898850528" className="apply-cta secondary">Call Recruitment</a>
            </div>
            <div className="contact-info-footer">
              <span>Email: <strong>career4@quarec.com</strong></span>
              <span>Ref: <strong>+91 9898850528</strong></span>
            </div>
          </div>
        </div><br/>
        <div className="featured-job-container">
          <div className="featured-job-image-wrapper">
            <img src={JobPostingImage5} alt="Current Job Openings" className="featured-job-img" />
            <div className="image-overlay-glow"></div>
          </div>
          <div className="featured-job-details">
            <div className="accent-pill">Confirm availability</div>
            <h2>EXHIBITION COORDINATOR CUM SALES EXECUTIVE</h2>
            <p>
              We're looking for passionate individuals to join our growing team. 
              Review our current openings and take the next step in your professional journey with Quarec Resources.
            </p>
            <div className="cta-group">
              <a href="mailto:career4@quarec.com" className="apply-cta primary">Share Your CV</a>
              <a href="tel:9898850528" className="apply-cta secondary">Call Recruitment</a>
            </div>
            <div className="contact-info-footer">
              <span>Email: <strong>career4@quarec.com</strong></span>
              <span>Ref: <strong>+91 9898850528</strong></span>
            </div>
          </div>
        </div><br/>
        <div className="featured-job-container">
          <div className="featured-job-image-wrapper">
            <img src={JobPostingImage3} alt="Current Job Openings" className="featured-job-img" />
            <div className="image-overlay-glow"></div>
          </div>
          <div className="featured-job-details">
            <div className="accent-pill">Confirm availability</div>
            <h2>Relattionship Executive</h2>
            <p>
              We're looking for passionate individuals to join our growing team. 
              Review our current openings and take the next step in your professional journey with Quarec Resources.
            </p>
            <div className="cta-group">
              <a href="mailto:career4@quarec.com" className="apply-cta primary">Share Your CV</a>
              <a href="tel:9898850528" className="apply-cta secondary">Call Recruitment</a>
            </div>
            <div className="contact-info-footer">
              <span>Email: <strong>career4@quarec.com</strong></span>
              <span>Ref: <strong>+91 9898850528</strong></span>
            </div>
          </div>
        </div><br/>
        <div className="featured-job-container">
          <div className="featured-job-image-wrapper">
            <img src={JobPostingImage4} alt="Current Job Openings" className="featured-job-img" />
            <div className="image-overlay-glow"></div>
          </div>
          <div className="featured-job-details">
            <div className="accent-pill">Confirm availability</div>
            <h2>Product Manager</h2>
            <p>
              We're looking for passionate individuals to join our growing team. 
              Review our current openings and take the next step in your professional journey with Quarec Resources.
            </p>
            <div className="cta-group">
              <a href="mailto:career4@quarec.com" className="apply-cta primary">Share Your CV</a>
              <a href="tel:9898850528" className="apply-cta secondary">Call Recruitment</a>
            </div>
            <div className="contact-info-footer">
              <span>Email: <strong>career4@quarec.com</strong></span>
              <span>Ref: <strong>+91 9898850528</strong></span>
            </div>
          </div>
        </div><br/>
        <div className="featured-job-container">
          <div className="featured-job-image-wrapper">
            <img src={JobPostingImage2} alt="Videographer cum Photographer" className="featured-job-img" />
            <div className="image-overlay-glow"></div>
          </div>
          <div className="featured-job-details">
            <div className="accent-pill">Hiring</div>
            <h2>VideoEditor — Ahmedabad</h2>
            <p>
              Join our creative team to capture stories that inspire and make an impact. Send your resume and portfolio to the email below.
            </p>
            <ul className="job-bullets">
              <li>Location: Ahmedabad</li>
              <li>Job Type: Full-time</li>
              <li>Experience: 1+ years</li>
            </ul>
            <div className="cta-group">
              <a href="mailto:career4@quarec.com" className="apply-cta primary">Send Resume & Portfolio</a>
              <a href="tel:9898850528" className="apply-cta secondary">Call Recruitment</a>
            </div>
            <div className="contact-info-footer">
              <span>Email: <strong>career4@quarec.com</strong></span>
              <span>Phone: <strong>+91 9898850528</strong></span>
            </div>
          </div>
        </div>
        <br/>
        <div className="featured-job-container">
          <div className="featured-job-image-wrapper">
            <img src={JobPostingImage1} alt="Current Job Openings" className="featured-job-img" />
            <div className="image-overlay-glow"></div>
          </div>
          <div className="featured-job-details">
            <div className="accent-pill">Confirm availability</div>
            <h2>Unlock Your Potential</h2>
            <p>
              We're looking for passionate individuals to join our growing team. 
              Review our current openings and take the next step in your professional journey with Quarec Resources.
            </p>
            <div className="cta-group">
              <a href="mailto:career4@quarec.com" className="apply-cta primary">Share Your CV</a>
              <a href="tel:9898850528" className="apply-cta secondary">Call Recruitment</a>
            </div>
            <div className="contact-info-footer">
              <span>Email: <strong>career4@quarec.com</strong></span>
              <span>Ref: <strong>+91 9898850528</strong></span>
            </div>
          </div>
        </div><br/>
         <div className="featured-job-container">
          <div className="featured-job-image-wrapper">
            <img src={JobPostingImage} alt="Current Job Openings" className="featured-job-img" />
            <div className="image-overlay-glow"></div>
          </div>
          <div className="featured-job-details">
            <div className="accent-pill">Confirm availability</div>
            <h2>Unlock Your Potential</h2>
            <p>
              We're looking for passionate individuals to join our growing team. 
              Review our current openings and take the next step in your professional journey with Quarec Resources.
            </p>
            <div className="cta-group">
              <a href="mailto:career4@quarec.com" className="apply-cta primary">Share Your CV</a>
              <a href="tel:9898850528" className="apply-cta secondary">Call Recruitment</a>
            </div>
            <div className="contact-info-footer">
              <span>Email: <strong>career4@quarec.com</strong></span>
              <span>Ref: <strong>+91 9898850528</strong></span>
            </div>
          </div>
        </div>
      </section>


     
      <Footer />
      <WhatsAppWidgetComponent />
    </div>
  );
}

export default Careers;
